var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowConnectionSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3268_2289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5H16.5C16.1023 13.5005 15.7211 13.6586 15.4399 13.9398C15.1587 14.221 15.0005 14.6023 15 15V16.5H10.8106L7.50003 13.1894V9H9.00003C9.39771 8.99954 9.77898 8.84136 10.0602 8.56016C10.3414 8.27895 10.4996 7.89768 10.5 7.5V3C10.4996 2.60232 10.3414 2.22105 10.0602 1.93984C9.77898 1.65864 9.39771 1.50046 9.00003 1.5H4.50003C4.10234 1.50046 3.72108 1.65864 3.43987 1.93984C3.15866 2.22105 3.00048 2.60232 3.00003 3V7.5C3.00048 7.89768 3.15866 8.27895 3.43987 8.56016C3.72108 8.84136 4.10234 8.99954 4.50003 9H6.00003V13.1894L2.46978 16.7197C2.4001 16.7894 2.34483 16.872 2.30712 16.963C2.26941 17.054 2.25 17.1515 2.25 17.25C2.25 17.3485 2.26941 17.446 2.30712 17.537C2.34483 17.628 2.4001 17.7106 2.46978 17.7803L6.21978 21.5303C6.28939 21.5999 6.37205 21.6552 6.46304 21.6929C6.55402 21.7306 6.65154 21.75 6.75003 21.75C6.84851 21.75 6.94603 21.7306 7.03702 21.6929C7.128 21.6552 7.21066 21.5999 7.28028 21.5303L10.8106 18H15V19.5C15.0005 19.8977 15.1587 20.2789 15.4399 20.5602C15.7211 20.8414 16.1023 20.9995 16.5 21H21C21.3977 20.9995 21.779 20.8414 22.0602 20.5602C22.3414 20.2789 22.4996 19.8977 22.5 19.5V15C22.4996 14.6023 22.3414 14.221 22.0602 13.9398C21.779 13.6586 21.3977 13.5005 21 13.5ZM4.50003 3H9.00003V7.5H4.50003V3ZM6.75003 19.9394L4.0606 17.25L6.75003 14.5606L9.43945 17.25L6.75003 19.9394ZM16.5 19.5V15H21V19.5H16.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3268_2289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowConnectionSvgrepoCom1);
export default __webpack_public_path__ + "static/media/flow-connection-svgrepo-com 1.572b006b2bb62090b4d29f5d35120167.svg";
export { ForwardRef as ReactComponent };